module.exports = __webpack_public_path__ + "static/wtb-9b36cb3069492f1456ba847a71d3c505.png";